import { Department, DepartmentGroup } from "../domain/department";
import { User, UserSelectionInformation } from "../domain/user";
import { IConfiguration } from "../domain/configuration";
import { UserAuthority } from "../domain/authentication";
import { IDrawableItem } from "../domain/document/items";
import { IPdfViewerVisibleControl } from "../domain/system";
import { IFixedPhraseTextDragParameter, IDocumentDataDragParameter } from "../components/dragging";

export class State {
  public token: string;
  public user: User;
  public department: Department;
  public configuration: IConfiguration;
  public extraConfiguration: IConfiguration;
  public userAuthority: UserAuthority;
  public hostName: string;
  public pdfViewerVisibleControlObjects: IPdfViewerVisibleControl[] = [];
  public fixedPhraseTextDragParameter: IFixedPhraseTextDragParameter = null;
  public documentDataDragParameter: IDocumentDataDragParameter = null;
  public userDepartments: Department[];
  public orderUser: User;
  public attendingUser: User;
  public clientIpAddress: string;
  public objectClipboard: IDrawableItem = null;
  public departmentGroup: DepartmentGroup;
  public referenceableDepartmentGroups: DepartmentGroup[];
  public isManualCloseable: boolean;
  public isDepartmentGroupScopeEnable: boolean;
  public userSelection: UserSelectionInformation;
}
